/**
 * Returns a WhatsApp-style day label for a given ISO date string.
 *
 * Today        → "Aujourd'hui"
 * Yesterday    → "Hier"
 * < 7 days ago → weekday name (e.g. "Lundi")
 * Older        → DD/MM/YYYY
 *
 * @param {string|number|Date} iso
 * @param {string} locale  Default 'fr-FR'
 */
export function formatDayLabel(iso, locale = 'fr-FR') {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const that = new Date(d);
  that.setHours(0, 0, 0, 0);
  const diffMs = today - that;
  const oneDay = 24 * 60 * 60 * 1000;

  if (diffMs === 0) {
    return locale.startsWith('fr') ? "Aujourd'hui" : 'Today';
  }
  if (diffMs === oneDay) {
    return locale.startsWith('fr') ? 'Hier' : 'Yesterday';
  }
  if (diffMs > 0 && diffMs < 7 * oneDay) {
    return d.toLocaleDateString(locale, { weekday: 'long' });
  }
  return d.toLocaleDateString(locale, { day: '2-digit', month: '2-digit', year: 'numeric' });
}
